import React from "react";
import styles from "./ClusterTypeChip.module.scss";
import { clusterTypeToText } from "../../utils/functions/enumToText";
import { ClusterTypes } from "../../types/enums";

interface Props {
  type: number;
  isActive?: boolean;
  onClick?: () => void;
  compact?: boolean;
}

export const ClusterTypeChip: React.FC<Props> = ({
  type,
  isActive,
  onClick,
  compact,
}) => {
  const label = clusterTypeToText(type as ClusterTypes);

  return (
    <button
      type="button"
      className={`${styles.Chip} ${compact ? styles.Compact : ""}`}
      data-active={isActive || undefined}
      onClick={onClick}
    >
      <span className={styles.BgName} aria-hidden="true">
        {label}
      </span>
      <span className={styles.Label}>{label}</span>
    </button>
  );
};